export default __webpack_public_path__ + "static/media/Spysome.b7d3cc20.mp3";